import axios from 'axios'
import { FetchTrackerDataInput, OrderDataInterface } from './types'
import { normalizeApiBaseUrl } from './utils'

export async function fetchTrackerData({
  orderId,
  apiBaseUrl,
}: FetchTrackerDataInput): Promise<OrderDataInterface> {
  const response = await axios.get<OrderDataInterface>(
    `${normalizeApiBaseUrl(apiBaseUrl)}/orders/${orderId}/status`
  )

  return response.data
}

export const fetchOrder = async (
  orderId: string,
  apiBaseUrl: string
): Promise<OrderDataInterface> => {
  return fetchTrackerData({ orderId, apiBaseUrl })
}
